module.exports = __webpack_public_path__ + "static/media/ok.b9381485.svg";